import ScaleAnalog from '../components/ScaleAnalog'
import { PageWrapper } from '../styles/GlobalStyles'

const scaling = () => {
	return (
		<PageWrapper>
			<ScaleAnalog />
		</PageWrapper>
	)
}

export default scaling
